<template>
  <div class="home">
    <Header />
    <Foucs :banners="home.banners" />
    <div class="main">
      <!-- <div class="ensure"></div> -->
      <Product :products="home.products"
               :brands="home.productbrands"
               @onBrandId="onBrandId" />
      <!-- <Laptop :products="home.laptop"
              :brands="home.laptopbrands"
              @onBrandId="onBrandId" /> -->

      <Service />
      <Process />

      <FooterSlogan />
    </div>
   
    <!-- <div class="zhimabg"
         @click="onZhima"
         v-if="endtime<20190820105406498"></div> -->
    <Footer />
  </div>
</template>

<script>
import { NowTimeCode } from "@/utils/index";

import Header from "@/components/PC/Common/Header.vue";
import Footer from "@/components/PC/Common/Footer.vue";
import FooterSlogan from "@/components/PC/Common/FooterSlogan.vue";
import Foucs from "@/components/PC/Home/Foucs.vue";
import Product from "@/components/PC/Home/Product.vue";
import Laptop from "@/components/PC/Home/Laptop.vue";
import Service from "@/components/PC/Home/Service.vue";
import Process from "@/components/PC/Home/Process.vue";

export default {
  name: "Order",
  data () {
    return {
      active: 2,
      ordersn: {},
      endtime: NowTimeCode()
    };
  },
  components: {
    Header,
    Footer,
    Foucs,
    Product,
    Laptop,
    Service,
    Process,
    FooterSlogan,
  },
  mounted: function () {
    console.log(1, this.home);
  },
  computed: {
    home () {
      return this.$store.state.home.home;
    }
  },
  methods: {
    fetchHomeData () {
      let params = {};
      this.$store.dispatch("home/fetchHomeData", { params }).then(() => {
      });
    },
    onZhima () {
      let url = "https://cuxiao.m.suning.com/scms/wapdn03669.html?utm_source=pl-00005&utm_medium=hp-shs-bn-w1-m"
      window.location.href = url;
    },
    onBrandId (data) {
      let params = {
        LaptopId: data.LaptopId,
        PhoneId: data.PhoneId
      }
      this.$store.dispatch("home/fetchHomeData", { params }).then(() => {
      });
    }
  },
  created () {
    this.fetchHomeData();
  }
};
</script>
<style>
.home {
  background: #f5f8fa;
}
.main{
  background: url(https://image.suhuishou.com/attached/upload/20220918/20220918130758_2537.png) 0 bottom no-repeat;
  background-size: 1171px 1134px;
}
/* .container .ensure {
  width: 1232px;
  height: 145px;
  margin: -50px auto 0;
  background: url(../../../assets/image/ensure.png?1223) center center no-repeat;
  background-size: 100%;
  border-radius: 5px;
  z-index: 9999;
  position: relative;
} */
.buynewbg {
  display: block;
  background: url(../../../assets/image/buyNewBg.png) center center no-repeat;
  background-size: 1920px 520px;
  width: 100%;
  height: 520px;
}
.xlbg,
.zybg {
  display: block;
  background: url(../../../assets/image/xinlai.png) center center no-repeat;
  background-size: 1920px 383px;
  width: 100%;
  height: 383px;
  margin: 50px auto;
}
.xlbg a,
.zybg a {
  display: block;
  width: 100%;
  height: 100%;
}
.zybg {
  background: url(../../../assets/image/zhuanye.png) center center no-repeat;
  margin-top: 100px;
}
.zhimabg {
  width: 152px;
  height: 85px;
  background: url(https://image.suhuishou.com/attached/image/20190813/20190813115001_17373.jpg)
    no-repeat;
  background-size: 100%;
  position: fixed;
  left: 20px;
  bottom: 240px;
}
</style>
